//+1 (###) ###-####
const PHONE_FORMAT = {
  0: '+',
  1: '1',
  2: ' ',
  3: '(',
  7: ')',
  8: ' ',
  12: '-',
}

export { PHONE_FORMAT }
